import { request, API_V1_PREFIX, type RequestOptions } from "./client";
import type { UserPublic } from "./types";

export async function getMe(token: string, options: Omit<RequestOptions, "token"> = {}): Promise<UserPublic> {
  return request<UserPublic>(`${API_V1_PREFIX}/users/me`, { method: "GET" }, { ...options, token });
}

export async function updateMe(
  data: Partial<Pick<UserPublic, "full_name" | "institution" | "phone" | "city" | "avatar_url">>,
  token: string,
): Promise<UserPublic> {
  return request<UserPublic>(
    `${API_V1_PREFIX}/users/me`,
    {
      method: "PUT",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function deleteMe(token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/users/me`, { method: "DELETE" }, { token });
}

export async function createUser(
  input: { name: string; email: string; school: string; password: string },
  options: RequestOptions = {},
): Promise<UserPublic> {
  const payload = {
    email: input.email.trim().toLowerCase(),
    password: input.password,
    full_name: input.name.trim(),
    institution: input.school.trim(),
    is_active: true,
  };

  return request<UserPublic>(
    `${API_V1_PREFIX}/users`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload),
    },
    options,
  );
}
